module.exports = __webpack_public_path__ + "img/[无语].19bed64b.svg";